export default function PageHero({
  eyebrow,
  title,
  tagline,
  image,
  align = "center",
  accent = "cyan",
}) {
  const accentColor =
    accent === "magenta"
      ? "#FF00FF"
      : accent === "lime"
        ? "#9FFF00"
        : accent === "orange"
          ? "#FF9900"
          : "#00FFFF";

  return (
    <section className="relative isolate overflow-hidden border-b border-mgfc-border/80">
      {image && (
        <>
          <div
            className="absolute inset-0 -z-10 bg-cover bg-center duotone-magenta-cyan"
            style={{ backgroundImage: `url(${image})` }}
          />
          <div className="absolute inset-0 -z-10 duotone-magenta-cyan-overlay" />
          <div
            className="absolute inset-0 -z-10"
            style={{
              background:
                "linear-gradient(180deg, rgba(9,0,20,0.5) 0%, rgba(9,0,20,0.65) 60%, #090014 100%)",
            }}
          />
        </>
      )}
      <div
        className="absolute inset-x-0 top-0 -z-10 h-px"
        style={{
          background: `linear-gradient(90deg, transparent, ${accentColor}, transparent)`,
        }}
      />

      <div
        className={[
          "mx-auto flex min-h-[46vh] max-w-7xl flex-col gap-4 px-4 py-20 sm:py-28 lg:px-8",
          align === "left" ? "items-start text-left" : "items-center text-center",
        ].join(" ")}
      >
        {eyebrow && (
          <p
            className="font-mono text-xs uppercase tracking-[0.4em]"
            style={{ color: accentColor }}
          >
            <span className="opacity-60">/// </span>
            {eyebrow}
          </p>
        )}
        <h1 className="font-display text-5xl font-black uppercase leading-[0.95] tracking-tight sm:text-7xl md:text-8xl">
          <span className="gradient-text drop-shadow-[0_0_25px_rgba(255,0,255,0.45)]">
            {title}
          </span>
        </h1>
        {tagline && (
          <p className="mt-2 max-w-2xl font-mono text-sm uppercase tracking-[0.35em] text-mgfc-fg/70 sm:text-base">
            {tagline}
          </p>
        )}
      </div>
    </section>
  );
}
